export default __webpack_public_path__ + "static/media/image.a44c6010.svg";